import { css } from '@emotion/css';

export const cheeriosTextCss = css`
  width: fit-content;
`;
